import React from "react";

export const Layout = ({ children }) => (
  <div
    style={{
      width: "100vw",
      height: "auto",
      background:
        "linear-gradient(250deg, #7b2ff7, #f107a3)",
    }}
  >
    {children}
  </div>
);
